<template>
  <v-container class="mt-5">
    <alert />
    <v-data-table :headers="headers" :items="bankers" dense class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title class="text-h6">Bankers</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog persistent v-model="dialog" max-width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Add Banker
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="orange lighten-5">
                <span class="text-h5">
                  {{ edit ? "Edit" : "Add" }} Bankers
                </span>
              </v-card-title>

              <v-card-text class="mt-10">
                <v-container>
                  <v-row dense>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <v-text-field
                        outlined
                        placeholder="Add Banker Name"
                        label="Banker Name"
                        v-model="formData.name"
                        dense
                        :rules="rules.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <v-text-field
                        outlined
                        placeholder="Add Address"
                        label="Address"
                        v-model="formData.address"
                        dense
                        :rules="rules.address"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="clearForm"> Cancel </v-btn>
                <v-btn color="primary" text @click="save"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="blue" @click="update(item)">
          mdi-pencil
        </v-icon>
        <v-icon small color="red" @click="remove(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { AuthService } from "../../../auth";
import { helper } from "../../../../utils";
import Alert from "../../../../components/Alert";

export default {
  name: "Banker",
  components: { Alert },
  data: () => ({
    dialog: false,
    edit: false,
    formData: {
      name: "",
      address: "",
    },
    headers: [
      {
        text: "Banker Name",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Banker Address", value: "address" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),

  mounted() {
    this.$store.dispatch("Profile/getBankers");
  },

  computed: {
    rules() {
      return {
        BankerName: [(v) => !!v || "BankerName is required"],
        address: [(v) => !!v || "address is required"],
      };
    },

    bankers() {
      return this.$store.getters["Profile/bankers"];
    },
  },

  methods: {
    clearForm: function () {
      this.formData = { name: "", discipline: "", regNo: "" };

      this.dialog = false;
      this.edit = false;
    },

    update: function (payload) {
      this.formData = { ...payload };
      this.edit = true;
      this.dialog = true;
    },

    remove(item) {
      this.$confirm.show({
        title: "Delete this Banker?",
        text: `Are you sure you want to delete?`,
        onConfirm: () => {
          this.$store.dispatch("Profile/removeBanker", { ...item });
        },
      });
    },

    save: function () {
      let isValid = true;
      for (const key in this.formData) {
        if (this.$refs[key])
          isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid) {
        let data = { ...this.formData };
        data.profileID = AuthService.user.profile.ProfileID;

        if (this.edit) {
          data.lineNo = parseInt(data.lineNo);
          data.EntryNo = this.formData.EntryNo
            ? parseInt(this.formData.EntryNo)
            : parseInt(this.bankers.length + 1);
        }

        this.$store.dispatch(
          `Profile/${this.edit ? "updateBanker" : "addBanker"}`,
          helper.prepareFormData(data)
        );

        this.clearForm();
      }
    },
  },
};
</script>

<style scoped></style>
